/** Full-viewport shell: background + horizontal padding used by most pages. */
export const pageWrapClass = 'min-h-dvh bg-slate-100 px-4 py-8 sm:px-6';

/**
 * Primary content column for signed-in flows (home, wallet, swap, transfer, settings, token detail).
 * Single max-width keeps layouts aligned across navigation.
 */
export const appMainClass = 'mx-auto w-full max-w-3xl space-y-6';

/** Admin UI (wide tables). */
export const adminMainClass =
  'mx-auto w-full max-w-6xl rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm';

/** Login / registration card (narrow). */
export const authCardClass =
  'mx-auto w-full max-w-md rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm';

/** Narrow centered panel for forbidden / empty states (same width as login card). */
export const narrowPanelNeutral =
  'mx-auto max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-sm';

export const narrowPanelError =
  'mx-auto max-w-md rounded-2xl border border-red-200 bg-white p-6 shadow-sm';
